import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import useSmartBack from "../../hooks/useSmartBack";
function Clientrisk() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [croptions, setcroptions] = useState([]);
  const [pcroptions, setpcroptions] = useState([]);

  useEffect(() => {
    const getCurrentYearRevenue = async () => {
      setGlobalLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/clients/get_client_at_risk/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setcroptions(response.data.client_at_risk_with_contract);
        setpcroptions(response.data.client_at_risk_with_role);
        console.log(response.data);
      } catch (error) {
        setGlobalLoading(false);
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getCurrentYearRevenue();
  }, []);

  const columns = [
    {
      accessorKey: "clients",
      header: "Client",
      size: 70,
      Cell: (info) => {
        return (
          <Link
            to={`/client/view/${info.row.original.company_id}`}
          >
            <b>{info.cell.getValue()}</b>
          </Link>
        );
      },
    },
    {
      accessorKey: "group_name",
      header: "Group Name",
      size: 70,
    },
    {
      accessorKey: "bd_by",
      header: "BD By",
      size: 70,
    },
    {
      accessorKey: "clientManaged",
      header: "Client Managed",
      size: 70,
    },
    {
      accessorKey: "origin",
      header: "Origin",
      size: 70,
    },
    {
      accessorKey: "industrymaster",
      header: "Industry (Maj)",
      size: 100,
    },
    {
      accessorKey: "industry",
      header: "Industry (Min)",
      size: 100,
    },
  ];

  const columns1 = [
    {
      accessorKey: "clients",
      header: "Client",
      size: 70,
      Cell: (info) => {
        return (
          <Link
            to={`/client/view/${info.row.original.company_id}`}
          >
            <b>{info.cell.getValue()}</b>
          </Link>
        );
      },
    },
    {
      accessorKey: "group_name",
      header: "Group Name",
      size: 70,
    },
    {
      accessorKey: "bd_by",
      header: "BD By",
      size: 70,
    },
    {
      accessorKey: "clientManaged",
      header: "Client Managed",
      size: 70,
    },
    {
      accessorKey: "origin",
      header: "Origin",
      size: 70,
    },
    {
      accessorKey: "industrymaster",
      header: "Industry (Maj)",
      size: 100,
    },
    {
      accessorKey: "industry",
      header: "Industry (Min)",
      size: 100,
    },
  ];

  const handleBack = useSmartBack("/client/list");
  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Client At Risk</h2>
          </div>
          <div className="my-auto">
            <button
                className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
             onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-1"></i> Back

            </button>
          </div>
        </div>

        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-body custom-div">
              <nav
                className="nav nav-style-6 nav-pills mb-3 nav-justified d-sm-flex d-block"
                role="tablist"
              >
                <a
                  className="nav-link active"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-current="page"
                  href="#nav-products-justified"
                  aria-selected="true"
                  tabindex="-1"
                >
                  Active Roles But No Active Contract
                  <span className="badge bg-info-transparent ms-1">
                    {croptions.length}
                  </span>
                </a>
                <a
                  className="nav-link"
                  data-bs-toggle="tab"
                  role="tab"
                  href="#nav-cart-justified"
                  aria-selected="false"
                >
                  Active Contracts But No Active Roles
                  <span className="badge bg-info-transparent ms-1">
                    {pcroptions.length}
                  </span>
                </a>
              </nav>
              <div className="tab-content">
                <div
                  className="tab-pane text-muted active show"
                  id="nav-products-justified"
                  role="tabpanel"
                >
                  <div className="custom-datatable-filter table-responsive">
                    <MaterialReactTable
                      columns={columns}
                      data={croptions}
                      initialState={{
                        pagination: { pageSize: 100 },
                      }}
                      muiTableBodyCellProps={{
                        sx: {
                          padding: "2px 4px", // compact cell padding
                        },
                      }}
                      muiTableHeadCellProps={{
                        sx: {
                          padding: "2px 4px", // same as body cells
                          height: "30px", // or less
                        },
                      }}
                      muiTableBodyRowProps={({ row }) => {
                        return {
                          sx: {
                            height: "20px",
                          },
                        };
                      }}
                    />
                  </div>
                </div>
                <div
                  className="tab-pane text-muted "
                  id="nav-cart-justified"
                  role="tabpanel"
                >
                  <div className="custom-datatable-filter table-responsive">
                    <MaterialReactTable
                      columns={columns1}
                      data={pcroptions}
                      initialState={{
                        pagination: { pageSize: 100 },
                      }}
                      muiTableBodyRowProps={({ row }) => {
                        return {
                          sx: {
                            height: "20px",
                          },
                        };
                      }}
                      muiTableBodyCellProps={{
                        sx: {
                          padding: "2px 4px", // compact cell padding
                        },
                      }}
                      muiTableHeadCellProps={{
                        sx: {
                          padding: "2px 4px", // same as body cells
                          height: "30px", // or less
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Clientrisk;
